import { useEffect, useRef } from 'react';

import styles from './CategoryTabs.module.css';

interface CategoryTabsProps {
  label: string;
  categories: Array<{ id: string; name: string }>;
  active: number;
  onSelect: (index: number) => void;
}

/** Horizontal, scrollable filter pills. The active one scrolls into view. */
export function CategoryTabs({ label, categories, active, onSelect }: CategoryTabsProps) {
  const refs = useRef<Array<HTMLButtonElement | null>>([]);

  useEffect(() => {
    refs.current[active]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }, [active]);

  return (
    <nav aria-label={label} className={styles.tabs}>
      {categories.map((c, i) => (
        <button
          key={c.id}
          ref={(el) => { refs.current[i] = el; }}
          type="button"
          onClick={() => onSelect(i)}
          aria-current={i === active}
          className="chip"
        >
          {c.name}
        </button>
      ))}
    </nav>
  );
}
